import { render, staticRenderFns } from "./exhibition-release-new-reject.vue?vue&type=template&id=5e4571fb&scoped=true&"
import script from "./exhibition-release-new-reject.vue?vue&type=script&lang=js&"
export * from "./exhibition-release-new-reject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4571fb",
  null
  
)

export default component.exports